import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Footer.css';
import FooterBanner from './FooterBanner';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const showBanner =
    !location.pathname.includes('refund') &&
    !location.pathname.includes('privacy') &&
    !location.pathname.includes('terms');

  const icons = [
    { url: './assets/icons/instagram.png', link: 'https://insta.openinapp.co/ccxw1', height: '40', width: '40' },
    { url: './assets/icons/youtube.png', link: 'https://www.youtube.com/@meharshbhagat', height: '40', width: '40' },
    { url: './assets/icons/telegram.png', link: 'https://telegram.openinapp.co/i1n51', height: '40', width: '40' },
    { url: './assets/icons/whatsapp.png', link: 'https://wa.me/9310397823', height: '30', width: '30' },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // helper for offset-based smooth scroll to in-page section
  const scrollToSectionById = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const headerEl = document.querySelector('header.header');
    const offset = headerEl ? headerEl.offsetHeight : 0;
    const y = el.getBoundingClientRect().top + window.scrollY - offset - 4;
    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  // Navigate to Home and scroll to a section (About/Story/Why/Resources)
  const handleFooterNavClick = (e, sectionId) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      // Go to home with hash. Header's hash-listener (in your Header.js) will smooth scroll.
      navigate(`/#${sectionId}`);
    } else {
      scrollToSectionById(sectionId);
    }
  };

  return (
    <footer className="footer">
      {showBanner && <FooterBanner />}

      <div className="footer-container">
        <div className="container">
          <div className="footer-grid">
            <div className="navigation-links">
              <div className="media-query">
                <p className="query-heading">Need any help?</p>
                <p className="contact-heading">
                  • For Queries, Call Us At: <a href="tel:8188988788" className="phone">8188988788</a>
                </p>
                <p className="contact-heading">
                  • You’ll Receive Calls From: <span className="phone">8065184470</span>
                </p>
                <p className="contact-heading">
                  • Temporary WhatsApp Number: <a href="https://wa.me/9310397823" target="_blank" className="phone">9310397823</a>
                </p>
              </div>

              <div className="social-logos">
                <ul className="footer-social-links">
                  {icons.map((icon, index) => (
                    <li key={index}>
                      <a href={icon.link} target="_blank" rel="noopener noreferrer">
                        <img src={icon.url} alt="social icon" width={icon.width} height={icon.height} />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="footer-query">
              <div className="page-links">
                <a href="#about" onClick={(e) => handleFooterNavClick(e, 'about')}>ABOUT</a>
                <a href="#story" onClick={(e) => handleFooterNavClick(e, 'story')}>story</a>
                <a href="#why" onClick={(e) => handleFooterNavClick(e, 'why')}>why</a>
                <a href="#resources" onClick={(e) => handleFooterNavClick(e, 'resources')}>resources</a>
              </div>
            </div>
          </div>

          <div className="mobile-social-logos">
            <ul className="footer-social-links">
              {icons.map((icon, index) => (
                <li key={`m-${index}`}>
                  <a href={icon.link} target="_blank" rel="noopener noreferrer">
                    <img src={icon.url} alt="social icon" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <ul className="footer-links">
            <li><Link to="/contact" onClick={scrollToTop}>Contact Us</Link></li>
            <li><Link to="/privacy" onClick={scrollToTop}>Privacy Policy</Link></li>
            <li><Link to="/refund" onClick={scrollToTop}>Refund</Link></li>
            <li><Link to="/terms" onClick={scrollToTop}>Terms &amp; Conditions</Link></li>
          </ul>
          
        </div>

       
      </div>

      <div className="footer-bottom">
        <div className="footer-logo">
          <span className="logo-text">HARSH BHAGAT</span>
        </div>
        <p className="footer-copyright">
          © 2025 Vittaara Research LLP. All rights reserved.
          Trading involves risk and may not be suitable for all investors.
        </p>

         <p className='disclaimer'> <span>Disclaimer:</span> All content provided by Harsh Bhagat and Vittaara Research LLP is strictly for educational purposes only and does not constitute financial or investment advice. Users are solely responsible for their trading decisions, and the company holds no liability for any financial losses.</p>
      </div>
    </footer>
  );
};

export default Footer;